// Import the createSlice function from Redux Toolkit
import { createSlice } from '@reduxjs/toolkit';

// Define the initial state for filters
const initialState = {
  searchTerm: "", // Search term
  localisation: "", // Location (city or region)
  competences: "", // Selected skills
  certifications: "", // Selected certifications
  formations: "", // Selected trainings
  modeTravail: "", // Work mode (e.g., remote, hybrid)
  tempsTravail: "", // Work time (e.g., full-time, part-time)
  priceRange: [0, 1500], // Price range (minimum and maximum)
  competencesLogicOperator: "AND", // Logical operator for skills
  certificationsLogicOperator: "AND", // Logical operator for certifications
  formationsLogicOperator: "AND", // Logical operator for trainings
  anneesExperienceRange: [0, 30], // Years of experience range
  inter_exp: "", // Experience range filter
};

// Create a slice to manage filters
const filtersSlice = createSlice({
  name: 'filters', // Slice name
  initialState, // Initial state
  reducers: {
    // Updates the search term
    setSearchTerm(state, action) {
      state.searchTerm = action.payload;
    },
    // Updates the location
    setLocalisation(state, action) {
      state.localisation = action.payload;
    },
    // Updates the skills
    setCompetences(state, action) {
      state.competences = action.payload;
    },
    // Updates the certifications
    setCertifications(state, action) {
      state.certifications = action.payload;
    },
    // Updates the trainings
    setFormations(state, action) {
      state.formations = action.payload;
    },
    // Updates the work mode
    setModeTravail(state, action) {
      state.modeTravail = action.payload;
    },
    // Updates the work time
    setTempsTravail(state, action) {
      state.tempsTravail = action.payload;
    },
    // Updates the price range
    setPriceRange(state, action) {
      state.priceRange = action.payload;
    },
    // Updates the logical operator for skills
    setCompetencesLogicOperator(state, action) {
      state.competencesLogicOperator = action.payload;
    },
    // Updates the logical operator for certifications
    setCertificationsLogicOperator(state, action) {
      state.certificationsLogicOperator = action.payload;
    },
    // Updates the logical operator for trainings
    setFormationsLogicOperator(state, action) {
      state.formationsLogicOperator = action.payload;
    },
    // Updates the years of experience range
    setAnneesExperienceRange(state, action) {
      state.anneesExperienceRange = action.payload;
    },
    // Updates the experience range filter
    setInterExp(state, action) {
      state.inter_exp = action.payload;
    },
    // Resets all filters to their default values
    resetFilters(state) {
      state.searchTerm = "";
      state.localisation = "";
      state.competences = "";
      state.certifications = "";
      state.formations = "";
      state.modeTravail = "";
      state.tempsTravail = "";
      state.priceRange = [0, 1500];
      state.competencesLogicOperator = "AND";
      state.certificationsLogicOperator = "AND";
      state.formationsLogicOperator = "AND";
      state.anneesExperienceRange = [0, 30];
      state.inter_exp = "";
    },
  }
});

// Export actions to be used in components
export const {
  setSearchTerm,
  setLocalisation,
  setCompetences,
  setCertifications,
  setFormations,
  setModeTravail,
  setTempsTravail,
  setPriceRange,
  setCompetencesLogicOperator,
  setCertificationsLogicOperator,
  setFormationsLogicOperator,
  setAnneesExperienceRange,
  setInterExp,
  resetFilters,
} = filtersSlice.actions;

// Export the reducer to include it in the Redux store
export default filtersSlice.reducer;
